import React from "react";
import css from "./styles.module.css";

const CustomToolbar = (props: any) => {
    const date = new Date(props.parsedValue);
    return (
        <div className='metaforms__toolbar_wrapper'>
            <button className='metaforms__toolbar_wrapper_year' onClick={() => props.setOpenView("year")}>
                {date.getFullYear()}
            </button>
            <div className='metaforms__toolbar_wrapper_month_day_wrapper'>
                <button className='metaforms__toolbar_wrapper_month_day_wrapper_month' onClick={() => props.setOpenView("month")}>
                    {date.toLocaleString("default", { weekday: "short" }) + ","}
                    &nbsp;
                    {date.toLocaleString("default", { month: "short" })}
                    &nbsp;&nbsp;
                </button>
                <button className='metaforms__toolbar_wrapper_month_day_wrapper_day' onClick={() => props.setOpenView("day")}>
                    {date.toLocaleString("default", { day: "2-digit" })}
                </button>
            </div>
        </div>
    );
};
export default CustomToolbar;
